// A stone rampart segment, described the way age-of-mcp authors it: a central
// junction post whose height rises through the build stages (`STAGE_H`). Ported
// 1:1 from age-of-mcp's wall.ts. The source also grows connection arms out to
// neighbouring wall tiles and can convert into an arched gate, but those depend
// on a live connection mask / gate flag that the model library has no notion of,
// so this is the standalone segment (connections = 0, not a gate): just the post.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const POST_COLOR = "#8b9196";   // stone grey

// Rampart height (top of the wall) per build stage — it rises as it builds.
const STAGE_H = [0.12, 0.22, 0.36, 0.5];
const POST    = 0.24;   // junction post — square, and a touch taller

// The central post for build stage `s` — the always-drawn core of a segment.
function partsFor(s: number): Part[] {
  const h = STAGE_H[Math.max(0, Math.min(3, s))]!;
  const postH = h + 0.05;
  return [
    { geometry: new THREE.BoxGeometry(POST, postH, POST), color: POST_COLOR, position: [0, postH / 2, 0] },
  ];
}

export const wall = defineModel({
  id: "wall",
  tiles: { w: 1, h: 1 },
  batchId: "standard",
  name: "Wall",
  tags: ["building","wall","low-poly","age-of-mcp","classic","military"],
  summary: "Low-poly wall.",
  description: "A stone rampart segment, placed in runs to form a defensive wall.",
  author: "age-of-mcp",
  footprint: 0.32,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => partsFor(0) },
    { id: "stage-1", label: "Lower", parts: () => partsFor(1) },
    { id: "stage-2", label: "Upper", parts: () => partsFor(2) },
    { id: "complete", label: "Complete", parts: () => partsFor(3) },
  ],
  animations: [],
});
